interface SkeletonLoaderProps {
  count?: number;
}

export default function SkeletonLoader({ count = 8 }: SkeletonLoaderProps) {
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="animate-pulse">
          <div className="aspect-square rounded-lg bg-gray-200" />
          <div className="mt-2 h-4 w-3/4 rounded bg-gray-200" />
        </div>
      ))}
    </div>
  );
}
